import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Button, Box, InputLabel, FormControl, Select, MenuItem, TextField } from '@mui/material';

const validationSchema = Yup.object({});

interface UyelikSabitleriProps {
    sabit: any;
    onUpdate: (updatedValues: any) => Promise<void>;
}

const UyelikSabitleri: React.FC<UyelikSabitleriProps> = ({ sabit, onUpdate }) => {

    const handleSubmit = async (values: any) => {
        const updatedValues = {
            ...sabit,
            kvkMetni: values.kvkMetni,
            sicilOlusturma: values.sicilOlusturma,
            sicilTelKontrol: values.sicilTelKontrol,
            loginTelKontrol: values.loginTelKontrol,
        };
        await onUpdate(updatedValues);
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                kvkMetni: sabit?.kvkMetni || '',
                sicilOlusturma: sabit?.sicilOlusturma || '',
                sicilTelKontrol: sabit?.sicilTelKontrol || '',
                loginTelKontrol: sabit?.loginTelKontrol || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, dirty }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id="kvkMetni"
                                name="kvkMetni"
                                label="KVKK Metni"
                                value={values.kvkMetni || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                multiline
                                fullWidth
                                variant="outlined"
                                sx={{
                                    '& .MuiInputBase-root': { height: '200px' },
                                    '& .MuiInputBase-input': { height: '100% !important', overflow: 'auto !important' },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="sicilOlusturma-label">Sicil Oluşturma</InputLabel>
                                <Select
                                    labelId="sicilOlusturma-label"
                                    id="sicilOlusturma"
                                    name="sicilOlusturma"
                                    value={values.sicilOlusturma ?? ''}
                                    label="Sicil Oluşturma"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    sx={{ minHeight: 56 }}
                                >
                                    <MenuItem value="E">Evet</MenuItem>
                                    <MenuItem value="H">Hayır</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="sicilTelKontrol-label">Sicil Tel Kontrol</InputLabel>
                                <Select
                                    labelId="sicilTelKontrol-label"
                                    id="sicilTelKontrol"
                                    name="sicilTelKontrol"
                                    value={values.sicilTelKontrol ?? ''}
                                    label="Sicil Tel Kontrol"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    sx={{ minHeight: 56 }}
                                >
                                    <MenuItem value="E">Evet</MenuItem>
                                    <MenuItem value="H">Hayır</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="loginTelKontrol-label">Login Tel Kontrol</InputLabel>
                                <Select
                                    labelId="loginTelKontrol-label"
                                    id="loginTelKontrol"
                                    name="loginTelKontrol"
                                    value={values.loginTelKontrol ?? ''}
                                    label="Login Tel Kontrol"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    sx={{ minHeight: 56 }}
                                >
                                    <MenuItem value="E">Evet</MenuItem>
                                    <MenuItem value="H">Hayır</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Box textAlign={{ xs: 'center', md: 'right' }}>
                                <Button type="submit" variant="contained" disabled={!dirty}>
                                    Kaydet
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};

export default UyelikSabitleri;
